import React from "react";
import {Pie, PieChart, Tooltip} from "recharts";
import {CardBlock, EmptyCircle, MiniCardBlock} from './Evaluation.styled'


export default function EvaluationChartItem ({criteria,color,withCharts,total}) {
  function generateData(criteria) {
    let data = []
    criteria.forEach(criterion=> {
      const value =  criterion.groupScore ? criterion.groupScore : 0
      data.push({name: criterion.criterionCode, value: Number(value.toFixed(1))})
    })
    return data
  }
  const totalResult = total > 0 ? total.toFixed(1) : '0.0'
  return (
    <div>
      {withCharts ?
        <CardBlock>
        <span className="score">{totalResult}</span>
          {total && total > 0 ? <PieChart width={160} height={120}>
            <Pie
              dataKey="value"
              isAnimationActive={false}
              data={generateData(criteria)}
              cx="50%"
              cy="50%"
              outerRadius={30}
              fill={color}
              label
              minAngle={13}
            />
            <Tooltip/>
          </PieChart>
          :
          <EmptyCircle color={color}/>
          }
      </CardBlock>
      :
      <MiniCardBlock>
        <span className="score">{totalResult}</span>
      </MiniCardBlock>
      }
      </div>
  )
}





// WEBPACK FOOTER //
// ./src/sbtool/component/ProjectVersionParamsForm/EvaluationGrid/EvaluationChartItem.tsx